export enum UserStatus {
    LOGGED_IN = 1,
    LOGGED_OUT = 2
}
